import { useCallback, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const timeoutRef = useRef(null);

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/admin/logout`,
        { method: "POST" }
      );

      if (response.ok) {
        localStorage.clear();
        navigate("/login", { replace: true });
      }
    } catch (error) {
      console.error("-> -> handleLogout -> error->", error);
    }
  };

  const isInVideoCall = useCallback(() => {
    if (location.pathname === "/video-call") return true;

    try {
      const hasActiveCallWindow =
        window.opener &&
        window.opener.location &&
        window.opener.location.pathname === "/video-call";

      if (hasActiveCallWindow) return true;

      const activeCallSession = localStorage.getItem("activeCallSession");

      if (activeCallSession) {
        const callData = JSON.parse(activeCallSession);
        const now = new Date().getTime();
        const callStartTime = new Date(callData.startTime).getTime();
        const callDuration = 60 * 60 * 1000;

        if (now - callStartTime < callDuration) return true;
        else localStorage.removeItem("activeCallSession");
      }
    } catch (error) {
      console.error("-> -> Logout -> error->", error);
    }

    return false;
  }, [location.pathname]);

  const startInactivityTimer = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    timeoutRef.current = setTimeout(() => {
      if (isInVideoCall()) {
        startInactivityTimer();
        return;
      }

      handleLogout();
    }, 300000);
  }, [isInVideoCall]);

  useEffect(() => {
    startInactivityTimer();

    const resetTimer = () => {
      if (!isInVideoCall()) startInactivityTimer();
    };

    window.addEventListener("keydown", resetTimer);
    window.addEventListener("mousemove", resetTimer);

    return () => {
      clearTimeout(timeoutRef.current);

      window.removeEventListener("keydown", resetTimer);
      window.removeEventListener("mousemove", resetTimer);
    };
  }, [startInactivityTimer, isInVideoCall]);

  return null;
};

export default Logout;
